import React from 'react'

const IconSendMail = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 14 14'>
      <path
        fill='none'
        stroke='#eee'
        stroke-linecap='round'
        stroke-linejoin='round'
        d='m5.812 11l2.178 2.168a1.1 1.1 0 0 0 1.05.3a1.12 1.12 0 0 0 .809-.74l3.576-10.72A1.118 1.118 0 0 0 11.987.57L1.267 4.147a1.12 1.12 0 0 0-.74.859a1.1 1.1 0 0 0 .3 1l2.737 2.737l-.09 3.466zM13.106.79L3.564 8.742'
        stroke-width='1'
      />
    </svg>
  )
}

export default IconSendMail